import React from 'react';
import { motion } from 'framer-motion';
import { FileCheck, Shield, Calendar, Award } from 'lucide-react';
import './Approach.css';

function Approach() {
  const values = [
    { icon: <FileCheck size={24} />, title: 'Clear, defensible documentation' },
    { icon: <Shield size={24} />, title: 'Bona fide professional engagements' },
    { icon: <Calendar size={24} />, title: 'Structured, compliant itineraries' },
    { icon: <Award size={24} />, title: 'Long-term operational discipline' },
  ];

  return (
    <section id="our-approach" className="approach-section">
      <div className="section-container">
        <motion.div
          className="approach-content"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="approach-title">A Credibility-First Approach</h2>
          <p className="approach-description">
            We take a conservative, documentation-driven approach designed to withstand scrutiny
            from immigration authorities, enterprise clients, and professional partners.
          </p>

          <div className="approach-values">
            {values.map((value, index) => (
              <motion.div
                key={index}
                className="value-block"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: index * 0.1 }}
              >
                <div className="value-icon">{value.icon}</div>
                <span className="value-title">{value.title}</span>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}

export default Approach;
